import { Controller } from "@hotwired/stimulus"

// "Right now" vibe suggestion — surfaces the time-of-day-appropriate playlist
// from those on the page as a quick link. Progressive enhancement: with no JS
// nothing shows; uses the visitor's local clock. No fetch, no tracking.
//
// Expected markup (inside the discovery grid):
//   <section data-controller="playlist-filter playlist-vibe">
//     <div data-playlist-vibe-target="suggestion" class="hidden">
//       <a data-playlist-vibe-target="link" href="#"></a>
//     </div>
//     <a class="pl-sleeve" href="/playlists/cafe" data-theme="cafe"><h3>Lo-Fi Bossa Café</h3></a>
//   </section>
export default class extends Controller {
  static targets = ["suggestion", "link"]

  // Theme preference by part of day; first available on the page wins.
  static PREFERENCES = {
    morning: ["sunday_morning", "cafe", "study", "slow_afternoon"],
    afternoon: ["slow_afternoon", "cafe", "study"],
    evening: ["rainy", "late_night", "slow_afternoon"],
    night: ["late_night", "rainy"],
  }

  connect() {
    const card = this._pickCard()
    if (!card || !this.hasSuggestionTarget) return

    const href = card.getAttribute("href")
    const title = card.querySelector("h3")?.textContent?.trim()
    if (!href || !title) return

    if (this.hasLinkTarget) {
      this.linkTarget.setAttribute("href", href)
      this.linkTarget.textContent = title
    }
    this.suggestionTarget.classList.remove("hidden")
  }

  _pickCard() {
    const cards = Array.from(this.element.querySelectorAll("a.pl-sleeve[data-theme]"))
    if (!cards.length) return null

    const order = this.constructor.PREFERENCES[this._partOfDay()] || []
    for (const theme of order) {
      const match = cards.find((c) => c.dataset.theme === theme)
      if (match) return match
    }
    return cards[0]
  }

  _partOfDay() {
    const h = new Date().getHours()
    if (h >= 5 && h < 11) return "morning"
    if (h >= 11 && h < 17) return "afternoon"
    if (h >= 17 && h < 22) return "evening"
    return "night"
  }
}
